import { useEffect } from 'react'

import seo from '../../content/seo.json'
import type { SeoPage } from '../types/content'

function upsertMeta(key: 'name' | 'property', value: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${key}="${value}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(key, value)
    document.head.appendChild(el)
  }
  el.content = content
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.rel = rel
    document.head.appendChild(el)
  }
  el.href = href
}

/**
 * Держит title/description/canonical в соответствии с текущим роутом.
 *
 * Сайт — SPA без SSR, поэтому все роуты получают мета-теги из index.html.
 * Без этого хука canonical на любой странице указывает на «/», то есть
 * подстраницы объявлены дублями главной. Пререндер на этапе сборки
 * вмораживает результат работы хука в статический HTML.
 */
export function useSeo(page: SeoPage) {
  useEffect(() => {
    const url = seo.origin + page.path

    document.title = page.title
    upsertMeta('name', 'description', page.description)
    upsertLink('canonical', url)

    upsertMeta('property', 'og:title', page.title)
    upsertMeta('property', 'og:description', page.description)
    upsertMeta('property', 'og:url', url)
    upsertMeta('property', 'og:image', seo.origin + seo.ogImage)

    upsertMeta('name', 'twitter:title', page.title)
    upsertMeta('name', 'twitter:description', page.description)
    upsertMeta('name', 'twitter:image', seo.origin + seo.ogImage)

    upsertMeta('name', 'robots', page.noindex ? 'noindex, follow' : 'index, follow')
  }, [page])
}
